import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export const GoogleTokenBanner = () => {
  const [health, setHealth] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    const check = () => api.get("/google/token-health")
      .then(({ data }) => alive && setHealth(data))
      .catch(() => {});
    check();
    const t = setInterval(check, 15 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!health || (!health.broken && !health.needs_write)) return null;
  return (
    <div data-testid="google-token-banner" className="mb-4 flex items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3">
      <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
      <p className="text-sm text-amber-900 flex-1">
        {health.broken ? (
          <>
            <span className="font-semibold">Je Google-koppeling is verlopen.</span>{" "}
            Afspraken plannen en agenda-sync werken niet totdat je opnieuw verbindt.
          </>
        ) : (
          <>
            <span className="font-semibold">Je Google-koppeling mist schrijfrechten.</span>{" "}
            Afspraken plannen werkt niet — verbind opnieuw om direct de juiste rechten te koppelen.
          </>
        )}
      </p>
      <button
        data-testid="google-token-banner-reconnect-btn"
        onClick={() => navigate("/settings")}
        className="rounded-full bg-amber-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-amber-700 transition-colors shrink-0"
      >
        Opnieuw verbinden
      </button>
    </div>
  );
};
